function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from "./Button";
export function CancelButton(_ref) {
  let {
    onClick,
    loading,
    disabled = false,
    icon = null,
    text = null,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "secondary",
    disabled: disabled,
    loading: loading,
    onClick: onClick
  }, props), text || 'Cancel');
}
;